import { useMutation } from "react-query";
import { updateMainAgreement } from "../../../../actions/CarrierAgreementMgmt/Agreements";

const useEditMainAgreement = () => {
  return useMutation(updateMainAgreement);
};

export default useEditMainAgreement;
